// Copyright (c) 2016 Deere & Company

import SearchFilters from '../state/search-filters';

export const getDefaultState = (filterBy, query, sortBy, sortDirection) =>

    new SearchFilters({
        filterBy,
        query,
        sortBy,
        sortDirection
    });

export default SearchFilters;



// WEBPACK FOOTER //
// ./src/shared/services/get-default-filter-state.js